import React, { createContext, useContext, useEffect } from "react";
import { useSelector } from "react-redux";
import { webSocketManager } from "../utils/WebSocketManager";

const WebSocketContext = createContext();

export const WebSocketProvider = ({ children }) => {
    const socketUrl = `wss://${window.location.host}/private-channel`;

    const userId = useSelector((state) => state.user?.user?.userid);
    const storeId = useSelector((state) => state.user?.user?.shopid);
    const JWT = useSelector((state) => state.user?.user?.token);
    const language_code = useSelector(state => state.user?.user?.language_code);

    useEffect(() => {
        if (!userId) return;

        let idleID = null;
        let timeoutID = null;

        const connect = () => {
            if (typeof window.requestIdleCallback === 'function') {
                idleID = window.requestIdleCallback(() => {
                    webSocketManager.connect(socketUrl, userId, storeId, JWT, language_code);
                }, { timeout: 2000 });
                return;
            }

            timeoutID = window.setTimeout(() => {
                webSocketManager.connect(socketUrl, userId, storeId, JWT, language_code);
            }, 800);
        };

        const isAdminRoute = window.location.pathname.startsWith('/adminpanel/');
        const catalogIsReady = document.documentElement.dataset.webappzCatalogReady === 'true';

        if (isAdminRoute || catalogIsReady) {
            connect();
        } else {
            window.addEventListener('webappz:catalog-ready', connect, { once: true });
        }

        return () => {
            window.removeEventListener('webappz:catalog-ready', connect);
            if (idleID !== null && typeof window.cancelIdleCallback === 'function') {
                window.cancelIdleCallback(idleID);
            }
            if (timeoutID !== null) {
                window.clearTimeout(timeoutID);
            }
            webSocketManager.socket?.close();
        };
    }, [userId, storeId, JWT, language_code, socketUrl]);

    return (
        <WebSocketContext.Provider value={webSocketManager}>
            {children}
        </WebSocketContext.Provider>
    );
};

export const useWebSocket = () => {
    return useContext(WebSocketContext);
};
